import { render, staticRenderFns } from "./DialogForRefuseDocument.vue?vue&type=template&id=295a325a&"
import script from "./DialogForRefuseDocument.vue?vue&type=script&lang=js&"
export * from "./DialogForRefuseDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295a325a')) {
      api.createRecord('295a325a', component.options)
    } else {
      api.reload('295a325a', component.options)
    }
    module.hot.accept("./DialogForRefuseDocument.vue?vue&type=template&id=295a325a&", function () {
      api.rerender('295a325a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/onboarding/components/DialogForRefuseDocument.vue"
export default component.exports